import type { DetailDeliveryAddressResponse } from '__generated__/api/auth';

export const CUSTOM_DELIVERY_OPTION = '직접 입력';

export const DELIVERY_REQUEST_OPTIONS = [
  '문 앞에 놓아주세요',
  '배송 전에 미리 연락 바랍니다',
  '부재 시 경비실에 맡겨주세요',
  '부재 시 전화주시거나 문자 남겨 주세요',
  CUSTOM_DELIVERY_OPTION,
] as const;

export interface DeliveryAddress {
  addressId: number;
  name: string;
  recipientName: string;
  phone: string;
  zipCode: string;
  address: string;
  addressDetail: string;
  entrancePasscode?: string;
  isPrimary: boolean;
}

export interface DeliveryMessage {
  option: string;
  customText: string;
}

export const INITIAL_DELIVERY_MESSAGE: DeliveryMessage = {
  option: '',
  customText: '',
};

export interface DeliveryChangeData {
  addressInfo?: DeliveryAddress;
  deliveryMessage?: Partial<DeliveryMessage>;
}

export const toDeliveryAddress = (
  res: DetailDeliveryAddressResponse,
): DeliveryAddress => ({
  addressId: res.addressId,
  name: res.name ?? '',
  recipientName: res.recipientName,
  phone: res.recipientNo,
  zipCode: res.zipCode,
  address: res.address,
  addressDetail: res.addressDetail,
  entrancePasscode: res.entrancePasscode,
  isPrimary: res.primaryYN,
});
